<template lang="pug">
  .col-12.p-0(v-if='currentUser.rights.browseStat = true')
    .content-wrapper.col-12.p-0.mb-5
      h3.chart-hearder Телефонные звонки
      ul.graph-tabs.nav.nav-tabs
        li.nav-item
          div(v-on:click="activeTopGraph = 'projects'" v-bind:class="['nav-link', {'active': activeTopGraph == 'projects'}]") По проектам
        li.nav-item
          div(v-on:click="activeTopGraph = 'users'; tabUsersReady = true" v-bind:class="['nav-link', {'active': activeTopGraph == 'users'}]") По операторам
        li.nav-item
          div(v-on:click="activeTopGraph = 'week'; tabWeekReady = true" v-bind:class="['nav-link', {'active': activeTopGraph == 'week'}]") По дням недели
        li.nav-item
          div(v-on:click="activeTopGraph = 'hour'; tabHourReady = true" v-bind:class="['nav-link', {'active': activeTopGraph == 'hour'}]") По часам в сутках
      div(v-show="activeTopGraph == 'projects'")
        .d-flex.align-items-center.justify-content-center.graph-container(v-if='!dataReady') Загрузка данных
          i.fas.fa-spinner.fa-pulse
        div(v-else)
          .d-flex.align-items-center.justify-content-center.graph-container(v-if='this.projects.length < minCount')
            h3.chart-txt Недостаточно данных для построения графика
          div(v-else)
            chart(v-if='dataReady' :chartdata='projects')
      div(v-show="activeTopGraph == 'users'")
        .d-flex.align-items-center.justify-content-center.graph-container(v-if='!dataReady') Загрузка данных
          i.fas.fa-spinner.fa-pulse
        div(v-else)
          .d-flex.align-items-center.justify-content-center.graph-container(v-if='this.users.length < minCount')
            h3.chart-txt Недостаточно данных для построения графика
          div(v-else)
            chart(v-if='dataReady && tabUsersReady' v-bind:chartdata='users')
            div(v-else-if='dataReady')
              | Загрузка данных
              i.fas.fa-spinner.fa-pulse
      div(v-show="activeTopGraph == 'week'")
        .d-flex.align-items-center.justify-content-center.graph-container(v-if='!dataReady')
          | Загрузка данных
          i.fas.fa-spinner.fa-pulse
        div(v-else)
          .d-flex.align-items-center.justify-content-center.graph-container(v-if='this.week.length < minCount')
            h3.chart-txt Недостаточно данных для построения графика
          div(v-else)
            chart(v-if='dataReady && tabWeekReady' v-bind:chartdata='week')
      div(v-show="activeTopGraph == 'hour'")
        .d-flex.align-items-center.justify-content-center.graph-container(v-if='!dataReady')
          | Загрузка данных
          i.fas.fa-spinner.fa-pulse
        div(v-else)
          .d-flex.align-items-center.justify-content-center.graph-container(v-if='this.hour.length < minCount')
            h3.chart-txt Недостаточно данных для построения графика
          div(v-else)
            chart(v-if='dataReady && tabHourReady' v-bind:chartdata='hour')
    .d-flex
      .col-6.p-0.mb-5
        .content-wrapper.mr-5.p-0
          h3.chart-hearder Цели звонков
          .d-flex.align-items-center.justify-content-center.graph-container(v-if='!dataReady')
            | Загрузка данных
            i.fas.fa-spinner.fa-pulse
          div(v-else)
            .d-flex.align-items-center.justify-content-center.graph-container(v-if='this.result.length < minCount')
              h5.chart-txt Недостаточно данных для построения графика
            div(v-else)
              chart(v-if='dataReady' v-bind:chartdata='result' graphType='PieChart')
      .col-6.p-0.mb-5
        .content-wrapper.p-0
          h3.chart-hearder Длительность ожидания
          .d-flex.align-items-center.justify-content-center.graph-container(v-if='!dataReady')
            | Загрузка данных
            i.fas.fa-spinner.fa-pulse
          div(v-else)
            .d-flex.align-items-center.justify-content-center.graph-container(v-if='this.hour.length < minCount')
              h5.chart-txt Недостаточно данных для построения графика
            div(v-else)
              chart(v-if='dataReady' v-bind:chartdata='hour' graphType='XYChartLines')
    //- .d-flex.p-0.pb-5
      .col-6.p-0
        .content-wrapper.mr-5.p-0
          h5.chart-hearder Время фактической работы операторов
          .d-flex.align-items-center.justify-content-center.graph-container(v-if='!dataReady')
            | Загрузка данных
            i.fas.fa-spinner.fa-pulse
          div(v-else)
            .d-flex.align-items-center.justify-content-center.graph-container.small(v-if='this.actualWorkTime.length < 1')
              h3.chart-txt Недостаточно данных для построения графика
            div(v-else)
              chartCluster(v-bind:clusterdata='actualWorkTime')
      .col-6.p-0.d-flex.justify-content-center
        .d-flex.align-items-center.justify-content-center(v-if='!dataReady')
          | Загрузка данных
          i.fas.fa-spinner.fa-pulse
        .col-12.p-0.d-flex.flex-wrap(v-else)
          .col-6.p-0.text-center
            .content-wrapper.sum-tabs.mr-2.mb-2
              span {{this.callsSum.daysum}}
              |   зв.
              br
              |   за день
          .col-6.p-0.text-center
            .content-wrapper.sum-tabs.ml-2.mb-2
              span {{this.callsSum.weeksum}}
              |   зв.
              br
              |   за неделю
          .col-6.p-0.text-center.align-self-end
            .content-wrapper.sum-tabs.mr-2
              span {{this.callsSum.monthsum}}
              |   зв.
              br
              |   за месяц
          .col-6.p-0.text-center.align-self-end
            .content-wrapper.sum-tabs.ml-2
              span {{this.callsSum.sum}}
              |   зв.
              br
              |    за всё время
  .alert.alert-warning.alert-dismissible.fade.show(v-else role='alert')
    <strong>Внимание!</strong> У Вас нет прав доступа в этот раздел.
    button.close(type='button' data-dismiss='alert' aria-label='Close')
      span(aria-hidden='true') &times;
</template>
<script>
import Chart from './chart'
import ChartСluster from './chartCluster'

export default {
  components: {
    ChartСluster,
    Chart
  },
  data () {
    return {
      week: [],
      hour: [],
      users: [],
      projects: [],
      result: [],
      wait: [],
      dataReady: false,
      activeTopGraph: 'projects',
      tabUsersReady: false,
      tabWeekReady: false,
      tabHourReady: false,
      minCount: 2,
      actualWorkTime: [
        {name: 'Иванов', hours: 5},
        {name: 'Петров', hours: 10},
        {name: 'Сидоров', hours: 7},
        {name: 'Кружков', hours: 25},
        {name: 'Котов', hours: 15},
        {name: 'Собакин', hours: 5}
      ],
      callsSum: {weeksum: 1000, daysum: 150, monthsum: 30000, sum: 100500}
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    currentUser () {
      return this.$store.getters.user
    }
  },
  methods: {
    setGraph (response) {
      this.week = response.data.week
      this.hour = response.data.hour
      this.users = response.data.users
      this.projects = response.data.projects
      this.result = response.data.result
      this.wait = response.data.wait
      this.projects.sort((prev, next) => prev.count - next.count)
      this.dataReady = true
    }
  },
  mounted () {
    this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getGraphDataAll')
      .then(this.setGraph)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stat.vue